export enum Authenticationstates {
    DEFAULT, TOKENPRESENT, REGISTER, LOGIN, AUTHENTICATED, ERROR, REGISTERED, APPROVED
}  